import { formatAmount } from 'utils/formatInfoNumbers'

/** null → '—' (unavailable), 0 → '$0.00' (confirmed zero), else formatted USD */
export const usd = (v: number | null | undefined): string => (v === null || v === undefined ? '—' : `$${formatAmount(v)}`)
export const num = (v: number | null | undefined, opts?: { isInteger?: boolean }): string => (v === null || v === undefined ? '—' : formatAmount(v, opts) ?? '—')
export const shortAddress = (a: string) => `${a.slice(0, 6)}…${a.slice(-4)}`
export const feeTierLabel = (feeTier?: number) => (feeTier === undefined ? '' : `${(feeTier / 10000).toString()}%`)
export const timeAgo = (iso?: string): string => {
  if (!iso) return '—'
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000))
  if (s < 60) return `${s} s ago`
  if (s < 3600) return `${Math.round(s / 60)} min ago`
  if (s < 86400) return `${Math.round(s / 3600)} h ago`
  return `${Math.round(s / 86400)} d ago`
}
